//  Angular imports
import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from 'environments/environment';
import { WINDOW_TOKEN } from 'app/window-token';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import versionJson from '../../../../version.json';
import { LoggerService, LogLevel } from 'app/services/logger.service';
import { AuthType } from 'app/models/auth-type';

@Component({
    selector: 'zf-splash',
    templateUrl: './splash.component.html',
    imports: [RouterModule],
    styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {
    public version: string = versionJson.version;

    private logger: ReturnType<LoggerService['getScopedLogger']>;
    private loggerService = inject(LoggerService);
    private oidcSecurityService = inject(OidcSecurityService);
    private window = inject<Window>(WINDOW_TOKEN);

    // add the specified class to the entire component
    // allows us to display only the product-information
    // at full height
    @HostBinding('class') public class = 'full-height';

    public readonly productName: string = environment.productName;

    public get currentYear() {
        return new Date().getFullYear();
    }

    public ngOnInit(): void {
        this.loggerService.setLogLevel('SplashComponent', LogLevel.WARN);
        this.logger = this.loggerService.getScopedLogger('SplashComponent');
        this.logger.debug("Authorizing: ", AuthType.CUSTOMER_FORTICLOUD);
        this.oidcSecurityService.checkAuthMultiple().subscribe({
            next: (results) => {
                this.logger.debug('Check multiple auth results:', JSON.stringify(results, null, 2));

                for (const i in results) {
                    const login = results[i];
                    if (login.configId == AuthType.CUSTOMER_FORTICLOUD) {
                        if (login.isAuthenticated) {
                            this.logger.debug(`User authenticated with config: ${login.configId}, re-authorizing...`);
                            this.oidcSecurityService.authorize(AuthType.CUSTOMER_FORTICLOUD);
                        } else {
                            this.logger.debug(`User NOT authenticated with config: ${login.configId}`);
                        }
                    }
                }
            },
            error: (err) => {
                this.logger.error('Auth error during checkAuthMultiple:', JSON.stringify(err, null, 2));
            }
        });
    }

    public redirectToLogin(): void {
        this.oidcSecurityService.authorize(AuthType.CUSTOMER_FORTICLOUD);
    }

    public redirectToRegister(): void {
        this.window.location.href = environment.registerUrl;
    }
}
